<div class="p-3 pb-7 flex flex-col adyen-checkout">
  @if (isLoading) {
    <ng-content select="[loadingState]"></ng-content>
  }
  <div
    #adyenContainer
    class="flex flex-col justify-center"
  ></div>
</div>
